import stringReplacer from './string';
export default function (_, mods, value) {
    var result = String(value);
    var sign = (mods.sign && value >= 0) ? '+' : '';
    if (mods.precision) {
        result = value.toFixed(mods.precision);
    }
    return stringReplacer('s', mods, sign + result);
}
